import { isServerSide } from '@r1-frontend/shared/helpers/ssr';

export const isPwa = () => {
    if (isServerSide()) {
        return false;
    }

    const mql = typeof window.matchMedia === 'function'
        ? window.matchMedia('(display-mode: standalone)')
        : null;

    return Boolean(mql?.matches ||
        (window.navigator as typeof window.navigator & { standalone?: boolean }).standalone);
};
